import { MemoCircleCheck } from '../../../assets/icons/MemoCircleCheck';

export type ApplianceCareTermsProps = {
  href: string;
  brand: string;
  alignIcon?: 'center' | 'start';
  variant?: 'panel' | 'plain';
};

const styles = {
  container: 'flex flex-row items-start gap-space-300 text-text-body',
  panel: 'bg-bg-main pt-space-400 pb-space-600 px-space-600 rounded-radius-200',
  icon: 'w-6 h-6 flex items-center justify-center shrink-0',
  text: 'text-body text-text-body',
  link: 'text-body-link-strong',
};

export const ApplianceCareTerms = ({ href, brand, variant = 'panel' }: ApplianceCareTermsProps) => (
  <div className={`${styles.container} ${variant === 'panel' ? styles.panel : ''}`}>
    <span className={styles.icon}>
      <MemoCircleCheck />
    </span>
    <p className={styles.text}>
      Limitations and exclusions apply. Please see the complete{' '}
      <a className={styles.link} href={href} target="_blank" rel="noopener noreferrer">
        {brand} Appliance Care terms and conditions
      </a>{' '}
      for details.
    </p>
  </div>
);
